import { useState } from "react";
import { Link } from "react-router-dom";
import { customerApi, formatApiErrorDetail } from "@/lib/api";
import SEO from "@/components/SEO";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await customerApi.post("/customer/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Fehler.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="on-dark violet-canvas flex-1 w-full flex items-center justify-center px-5 py-20">
      <SEO title="Passwort vergessen" />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo variant="butterfly" className="h-14 w-auto mx-auto mb-4" />
          <h1 className="font-serif text-4xl font-light text-[#FFF9F2]">Passwort vergessen</h1>
        </div>
        {sent ? (
          <div className="bg-[#FFF9F2] rounded-md p-7 text-center" data-testid="forgot-success">
            <p className="text-[#3A1E55] leading-relaxed">
              Falls ein Konto mit dieser Adresse existiert, haben wir dir eine E-Mail mit einem Link zum Zurücksetzen deines Passworts geschickt (gültig 1 Stunde).
            </p>
            <Link to="/anmelden" className="mt-6 inline-block text-[#632A8E] underline">Zur Anmeldung</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5 bg-[#FFF9F2] rounded-md p-7" data-testid="forgot-form">
            <p className="text-sm text-[#6E5A82]">Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen.</p>
            <div>
              <Label htmlFor="fp-email">E-Mail</Label>
              <Input id="fp-email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-white" />
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full bg-[#F4C542] text-[#32104F] hover:bg-[#D85CA4] rounded-md h-12">
              {loading ? "Senden…" : "Link senden"}
            </Button>
            <p className="text-sm text-center text-[#6E5A82]">
              <Link to="/anmelden" className="text-[#632A8E] underline">Zurück zur Anmeldung</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
